<div id="personalBox" class="rounded-element-with-border blurry-element-with-fallback vertical-layout">

    <img [src]="imageUrl" [attr.alt]="'Bild ' + fullName" class="responsive-personal-picture"/>

    <p class="heading centered-text">{{fullName}}</p>

    <p class="normal-text centered-text">{{jobTitle}}</p>

</div>
